import { AuthResources, RenderSvg } from 'components';
import React, { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';

const TopMenuElementComp = (): ReactElement => {
  return (
    <>
      <div className="topMenuElement">
        <>
          <NavLink to="/panel" className="topMenuElementItem">
            <div className="beforeAccent">
              <svg
                width="10"
                height="80"
                viewBox="0"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M 0 80 H 11 V 70 C 10 75.5 5.5 80 0 80 H 0 V 80 Z"
                  fill="#fff"
                />
              </svg>
            </div>
            <div className="topMenuElementItemBox">
              <div className="topMenuElementItemAccent" />
              <span className="topMenuElementItemSpan">
                <svg
                  width="32"
                  height="26"
                  viewBox="0 0 32 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29.0764 16.944C28.5577 16.944 28.1373 16.5234 28.1373 16.0047C28.1373 15.4858 28.5578 15.0653 29.0764 15.0653L31.9993 15.0654C31.7918 11.4478 30.3876 8.05682 27.9774 5.35192L25.9104 7.41936C25.7271 7.60283 25.4867 7.69451 25.2465 7.69451C25.0061 7.69451 24.7657 7.60283 24.5824 7.41936C24.2158 7.05242 24.2158 6.45776 24.5825 6.09072L26.6493 4.02328C23.9454 1.61227 20.5555 0.207719 16.9391 0V2.92395C16.9391 3.44271 16.5187 3.86328 16 3.86328C15.4815 3.86328 15.061 3.44271 15.061 2.92395V0C11.4447 0.207719 8.05482 1.61227 5.35086 4.02348L7.41768 6.09082C7.78449 6.45766 7.78449 7.05242 7.41768 7.41936C7.23428 7.60283 6.99401 7.69461 6.75364 7.69461C6.51338 7.69461 6.27301 7.60293 6.0897 7.41936L4.02298 5.35202C1.6126 8.05682 0.208536 11.4478 0.000986428 15.0654L2.92373 15.0653C3.44231 15.0653 3.86283 15.4858 3.86283 16.0047C3.86283 16.5234 3.44241 16.9441 2.92373 16.9441L0 16.9442C0.180448 20.0994 1.26974 23.0833 3.17809 25.6248C3.35548 25.861 3.6336 26 3.92886 26H28.0711C28.3665 26 28.6446 25.861 28.822 25.6248C30.7303 23.0832 31.8195 20.0994 32 16.9442L29.0764 16.944ZM21.8869 11.4443L19.3813 13.9509C19.7462 14.55 19.9567 15.2532 19.9567 16.0046C19.9567 18.1871 18.1817 19.9627 16 19.9627C13.8183 19.9627 12.0434 18.1871 12.0434 16.0046C12.0434 13.8222 13.8184 12.0467 16 12.0467C16.7513 12.0467 17.4542 12.2573 18.0532 12.6224L20.5589 10.1158C20.9256 9.74894 21.5202 9.74894 21.887 10.1158C22.2536 10.4826 22.2536 11.0775 21.8869 11.4443Z"
                    fill="#93B7E1"
                  />
                </svg>
                PANEL PRACOWNIKA
              </span>
            </div>
            <div className="afterAccent">
              <svg
                width="10"
                height="80"
                viewBox="0"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M 0 70 H 0 V 80 H 10 C 4.4772 80 0 75.5229 0 70 Z"
                  fill="#fff"
                />
              </svg>
            </div>
          </NavLink>
        </>
      </div>
    </>
  );
};

export default TopMenuElementComp;
